import {ImageService} from '../../shared/services/advtech/image/image.service';
import {ListEntity} from './list.entity';
import {getImgSize} from '../../../utils/content/image-size.utils';
import {AdvTechDateObject} from '../../shared/interfaces/advtech-date-object.interface';
import {ImageApiObject} from '../../shared/interfaces/image-api-object.interface';

/**
 * Class used to transform the image list api response to image entities
 * @class ImageListEntity
 * @extends {ListEntity}
 *
 * @description Class for images in the image listing component.
 * Describes the image height, width, id, type, original size, and creates an image URL with the resized image.
 */
export class ImageListEntity extends ListEntity {

  /**
   * url of the image to be displayed
   * @type {string}
   */
  imageUrl: string;

  /**
   * id of the image
   * @type {string}
   */
  id: string;

  /**
   * The date created object from Prism
   */
  dateCreated: AdvTechDateObject;

  /**
   * The 'image' type
   * @type {string}
   */
  type: string;

  /**
   * The image object from the api response
   * @type {ImageApiObject}
   */
  image: ImageApiObject;

  /**
   * The normal unresized url
   */
  normalUrl: string;

  /**
   * Resizes the images for the image listing page
   * @constructor
   * @param {any} obj The image object
   * @param {ImageService} imageService The ImageService instance
   */
  constructor(obj: any,
              public imageService: ImageService) {
    super(obj, imageService);
    this.dateCreated = obj.dateCreated;
    if (obj.image) {
      this.image = obj.image;
      this.normalUrl = this.imageService.buildImageUrl(obj.image.id);
      const imgWidth = parseInt(obj.image.width, 10);
      const imgHeight = parseInt(obj.image.height, 10);
      this.id = obj.id;
      this.type = 'Image';
      const screenWidth = Math.floor(screen.availWidth * window.devicePixelRatio);
      const screenHeight = Math.floor(screen.availHeight * window.devicePixelRatio);
      const origSize = `${screenWidth}x${screenHeight}`;
      this.imageUrl = this.imageService.buildResizedImageUrl(obj.image.id, imgHeight, imgWidth, getImgSize(origSize));
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/list/entities/image-list.entity.ts